import {Component, Input, OnInit} from '@angular/core'

@Component({
  selector: 'dmmp-detail-program-desc-mixta',
  templateUrl: './detail-program-desc-mixta.component.html'
})
export class DetailProgramDescMixtaComponent {
  @Input() identifier
  @Input() data
  active = 0
  duration = 'Duración estimada:'
  price = 'Valor del semestre:'

}
